module.exports = __webpack_public_path__ + "static/media/Nou_size_correction_optimized3.1842b09d.png";